import api from "../services/api";

export async function uploadFlowImage(file) {
  const formData = new FormData();
  formData.append("file", file);

  const { data } = await api.post("/api/whatsapp-flows/assets/image", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  if (!data.success) {
    throw new Error(data.error || "Image upload failed");
  }

  return data.url;
}

export async function fetchWaFlows(params = {}) {
  const { data } = await api.get("/api/wa-flows", { params });
  return data;
}

export async function getWaFlow(id) {
  const { data } = await api.get(`/api/wa-flows/${id}`);
  return data;
}

export async function saveWaFlow(payload) {
  const { data } = await api.post("/api/wa-flows", payload);
  return data;
}

export async function deleteWaFlow(id) {
  const { data } = await api.delete(`/api/wa-flows/${id}`);
  return data;
}
